import React, { useContext } from "react";
import { AuthContext, AuthContexType } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const { token } = useContext(AuthContext) as AuthContexType;
  return token ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default PublicRoute;
